import React, {
    useMemo,
    createContext,
    useContext,
    type PropsWithChildren,
} from "react"

import { usePortalEntitiesContext } from "~contexts/outfitter-provider"

interface PermissionsContextType {
    shouldShowActions: boolean
    shouldShowEarnings: boolean
    isLoading: boolean
    error?: Error | null
}

const PermissionsContext = createContext<PermissionsContextType>({
    shouldShowActions: false,
    shouldShowEarnings: false,
    isLoading: false,
    error: null,
})

export const usePermissions = () => useContext(PermissionsContext)

export default function PermissionsProvider({ children }: PropsWithChildren) {
    const { isPortalEntityOwner, isLoading, error } = usePortalEntitiesContext()

    // Right now, earnings and actions permissions are both based on the same thing.
    // Using two variables in case this changes.
    const shouldShowActions = isPortalEntityOwner
    const shouldShowEarnings = isPortalEntityOwner

    const value = useMemo(
        () => ({
            shouldShowActions,
            shouldShowEarnings,
            isLoading,
            error,
        }),
        [shouldShowActions, shouldShowEarnings, isLoading, error]
    )

    return (
        <PermissionsContext.Provider value={value}>
            {children}
        </PermissionsContext.Provider>
    )
}
